import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth as useOidcAuth } from "react-oidc-context";
import { Loader2 } from "lucide-react";

// Keycloak blocks login server-side (via its "Verify Email" required action)
// until an account's email is confirmed, so there's no "issue a token, then
// check email_verified" callback error to detect here anymore - just show a
// spinner while the Authorization Code + PKCE callback is being processed.
const hasAuthParams = (search) => {
  const params = new URLSearchParams(search);
  return params.has("code") || params.has("state") || params.has("error");
};

export default function AuthCallbackSpinner() {
  const { isLoading } = useOidcAuth();
  const location = useLocation();

  if (!isLoading || !hasAuthParams(location.search)) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 text-[#324c48]">
        <Loader2 className="h-8 w-8 animate-spin" />
        <p className="text-sm font-medium">Completing sign in...</p>
      </div>
    </div>
  );
}
